<template>
  <div>
    <v-btn
      color="primary"
      @click.prevent="abrirDialog()"
    >
      <v-icon left>mdi-content-save</v-icon>
      Atualizar
    </v-btn>
    <SysDialog
      v-model="dialog"
      titulo="Nome da categoria"
      @click:primary="save()"
      ocultar_botao_fechar
      content-class="bra-20"
    >
      <v-text-field
        v-model="nome_categoria"
        outlined
        single-line
        append-icon="mdi-magnify"
        label="Nome da Categoria"
        class="mx-4 mt-8 mb-3"
        :error-messages="nomeCategoriaErrors"
        @input="$v.nome_categoria.$touch()"
        @blur="$v.nome_categoria.$touch()"
      ></v-text-field>
    </SysDialog>
  </div>
</template>

<script>
import { required } from "vuelidate/lib/validators";
import SysDialog from "@/components/padraoDeLayout/SysDialog.vue";

export default {
  components: { SysDialog },
  props: {
    nome_categoria_prop: {
      type: String,
      required: true,
    },
  },
  validations: {
    nome_categoria: {
      required,
    },
  },
  data() {
    return {
      dialog: false,
      nome_categoria: "",
    };
  },
  computed: {
    nomeCategoriaErrors() {
      const errors = [];
      if (!this.$v.nome_categoria.$dirty) return errors;
      !this.$v.nome_categoria.required && errors.push("Campo Obrigatório.");
      return errors;
    },
  },
  methods: {
    abrirDialog() {
      this.nome_categoria = this.nome_categoria_prop;
      this.dialog = true;
    },
    fecharDialog() {
      this.dialog = false;
      this.nome_categoria = '';
    },
    save() {
      this.$v.$touch();

      if (!this.$v.$invalid) {
        this.$emit('atualizar-categoria-materia-prima', { nome_categoria: this.nome_categoria });
      }

      this.fecharDialog();
    },
  },
};
</script>

<style>
</style>
